import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Check, Share2 } from "lucide-react";
import { Modal } from "../common/Modal";

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  partyCode: string;
}

export const QRCodeModal: React.FC<QRCodeModalProps> = ({
  isOpen,
  onClose,
  partyCode,
}) => {
  const [copied, setCopied] = useState(false);
  const joinUrl = `${window.location.origin}/?partyCode=${partyCode}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(joinUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join Squad-a-Roke Party!",
          text: `Join our karaoke party with code ${partyCode}!`,
          url: joinUrl,
        });
      } catch (err) {
        console.log("Share skipped", err);
      }
    } else {
      handleCopyLink();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Party Join Code & QR">
      <div className="flex flex-col items-center text-center space-y-6 py-2">
        {/* QR Code Container */}
        <div className="p-4 bg-white rounded-3xl shadow-xl border-4 border-accent/30">
          <QRCodeSVG
            value={joinUrl}
            size={200}
            level="M"
            includeMargin={false}
          />
        </div>

        {/* Room Code */}
        <div className="space-y-1">
          <span className="text-[11px] font-bold uppercase tracking-wider text-text-muted">
            Party Code
          </span>
          <h4 className="text-4xl font-bold font-mono tracking-[0.25em] text-accent">
            {partyCode}
          </h4>
        </div>

        {/* Action Buttons */}
        <div className="w-full flex gap-3">
          <button
            onClick={handleCopyLink}
            className="flex-1 py-3 px-4 rounded-2xl bg-card border border-border hover:border-primary text-text-main text-xs font-semibold flex items-center justify-center gap-2 transition-all cursor-pointer"
          >
            {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
            <span>{copied ? "Link Copied!" : "Copy Link"}</span>
          </button>

          <button
            onClick={handleShare}
            className="flex-1 py-3 px-4 rounded-2xl bg-primary hover:bg-primary-hover text-white text-xs font-semibold flex items-center justify-center gap-2 transition-all shadow-lg shadow-primary/20 cursor-pointer"
          >
            <Share2 className="w-4 h-4" />
            <span>Share Invite</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};
